import React, { useEffect, useState } from 'react'
import config from '../coreFIles/config';
import toast, { Toaster } from 'react-hot-toast';
import Header from '../directives/header';
import Footer from '../directives/footer';
import Sidebar from '../directives/sidebar';
import ReactDatatable from '@ashvin27/react-datatable';
import { getNewsletterSubscriptionsListAction, deleteNewsletterSubscriptionAction } from '../Action/action'
import Swal from 'sweetalert2';
import Cookies from 'js-cookie';
import moment from 'moment';
const loginData = (!Cookies.get('loginSuccessBondiAdmin')) ? [] : JSON.parse(Cookies.get('loginSuccessBondiAdmin'));

const NewsletterSubscriptions = () => {
    const [subscriptionsList, setSubscriptionsList] = useState([]);
    
    useEffect(() => {
        if (!loginData?.email) {
            window.location.href = `${config.baseUrl}login`
        }        
        getSubscriptionsList(); 
    }, [])
   
    const getSubscriptionsList = async () => {
        // Get all records - ReactDatatable will handle pagination
        // Pass page: -1 to get all records
        let res = await getNewsletterSubscriptionsListAction({email: '', page: -1});
        if (res.success) {
            let data = res.data;			
            setSubscriptionsList(data);	
        }
        else
        {
            setSubscriptionsList([]);	
        }
    }
      
    const deleteSubscription = async (id) => {
        Swal.fire({
            title: 'Are you sure? ',
            text: "You want to Delete this subscription!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
        }).then(async (result) => {
            if (result.isConfirmed) {
                let res = await deleteNewsletterSubscriptionAction({'id': id});
                if (res.success) {
                    toast.success(res.msg);
                    getSubscriptionsList();
                } else {
                    toast.error(res.msg);
                }
            }
        });
    }

    const columns = [
        {
            key: "Sno.",
            text: "#",
            cell: (row, index) => index + 1,
        },
        {
            key: "id",
            text: "ID"
        },
        {
            key: "email",
            text: "Email",
            cell: (item) => {
                return (
                    <>
                        {item.email || '-'}
                    </>
                )
            }
        },
        {
            key: "created_on",
            text: "Subscribed Date",
            cell: (item) => {
                return (
                    <>
                        {item.created_on ? moment(item.created_on).format('DD/MM/YYYY HH:mm') : '-'}
                    </>
                )
            }
        },
        {
            key: "action",
            text: "Action",
            cell: (item) => {
                return (
                    <>
                        <button 
                            type="button" 
                            className="waves-effect waves-light btn btn-danger btn-sm" 
                            onClick={() => deleteSubscription(item.id)}
                        >
                            <i className='fa fa-trash'></i> Delete
                        </button>
                    </>
                )
            }
        }
    ];

    const configForTable = {
        page_size: 10,
        length_menu: [10, 20, 50],
        show_filter: true,
        show_pagination: true,
        pagination: "advance",
        button: {
            excel: false,
            print: false,
        },
    };
    

    return (
        <>
            <div className="wrapper">
                <Toaster />
                <Header />
                <Sidebar />
                <div className="content-wrapper">
                    <div className="container-full">
                        {/* Main content */}
                        <div className="content-header">
                            <div className="d-flex align-items-center">
                                <div className="me-auto">
                                    <h3 className="page-title mb-3 mb-md-5 pb-2">Newsletter Subscriptions</h3>
                                </div>
                            </div>
                            <hr />
                        </div>
                        <section className="content">
                            <div className="row">
                                <div className="col-lg-12 col-12">
                                    <div className="box">
                                        <div className="box-header with-border">
                                            <div className="row mb-15 align-items-center">
                                                <h4 className="box-title col-12 mb-2 mb-md-0">Newsletter Subscriptions ({subscriptionsList.length})</h4>
                                            </div>
                                        </div>
                                        <div className="box-body">
                                            <div className="table-responsive" style={{ overflowX: 'auto' }}>
                                                <ReactDatatable
                                                    config={configForTable}
                                                    records={subscriptionsList}
                                                    columns={columns}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>                       
                    </div>
                </div>      	
                <Footer />
            </div>
        </>
    )
}

export default NewsletterSubscriptions;

